let region = null

export function announce(message, priority = "polite") {
  if (!region) {
    region = document.createElement("div")
    region.setAttribute("aria-live", priority)
    region.setAttribute("aria-atomic", "true")
    region.classList.add("sr-only")
    document.body.appendChild(region)
  }
  region.textContent = ""
  requestAnimationFrame(() => {
    region.textContent = message
  })
}
